//export const Amsterdam1 = require('./travel/amsterdam1.jpeg');

/* AMSTERDAM */
import Amsterdam1 from './travel/amsterdam1.jpeg';
import Amsterdam2 from './travel/amsterdam2.jpeg';
import Amsterdam3 from './travel/amsterdam3.jpeg';
import Amsterdam5 from './travel/amsterdam5.jpeg';
import Amsterdam6 from './travel/amsterdam6.jpeg';
import Amsterdam7 from './travel/amsterdam7.jpeg';
import Amsterdam8 from './travel/amsterdam8.jpeg';
import Amsterdam9 from './travel/amsterdam9.jpeg';

import Austria1 from './travel/austria1.jpeg';
import Austria2 from './travel/austria2.jpeg';
import Austria3 from './travel/austria3.jpeg';
import Austria4 from './travel/austria4.jpeg';

import Beijing1 from './travel/beijing1.jpeg';
import Beijing2 from './travel/beijing2.jpeg';
import Beijing3 from './travel/beijing3.jpeg';
import Beijing4 from './travel/beijing4.jpeg';
import Beijing5 from './travel/beijing5.jpeg';
import Beijing6 from './travel/beijing6.jpeg';
import Beijing7 from './travel/beijing7.jpeg';
import Beijing8 from './travel/beijing8.jpeg';
import Beijing9 from './travel/beijing9.jpeg';
import Beijing10 from './travel/beijing10.jpeg';

import DR1 from './travel/dr1.jpg';
import DR3 from './travel/dr3.jpg';
import DR4 from './travel/dr4.jpg';
import DR5 from './travel/dr5.jpg';
import DR6 from './travel/dr6.jpg';
import DR7 from './travel/dr7.jpg';

import Guilin1 from './travel/guilin1.jpeg';
import Guilin2 from './travel/guilin2.jpeg';

import Heidelberg1 from './travel/heidelberg1.jpeg';
import Heidelberg2 from './travel/heidelberg2.jpeg';
import Heidelberg3 from './travel/heidelberg3.jpeg';
import Heidelberg4 from './travel/heidelberg4.jpeg';
import Heidelberg5 from './travel/heidelberg5.jpeg';
import Heidelberg6 from './travel/heidelberg6.jpeg';
import Heidelberg7 from './travel/heidelberg7.jpeg';
import Heidelberg8 from './travel/heidelberg8.jpeg';

import HongKong1 from './travel/hongkong1.jpeg';
import HongKong2 from './travel/hongkong2.jpeg';
import HongKong3 from './travel/hongkong3.jpeg';
import HongKong4 from './travel/hongkong4.jpeg';
import HongKong5 from './travel/hongkong5.jpeg';

import Italy1 from './travel/italy1.jpeg';
import Italy2 from './travel/italy2.jpeg';
import Italy3 from './travel/italy3.jpeg';
import Italy4 from './travel/italy4.jpeg';
import Italy5 from './travel/italy5.jpeg';
import Italy6 from './travel/italy6.jpeg';
import Italy7 from './travel/italy7.jpeg';
import Italy8 from './travel/italy8.jpeg';
import Italy9 from './travel/italy9.jpeg';
import Italy10 from './travel/italy10.jpeg';
import Italy11 from './travel/italy11.jpeg';

import Kenya1 from './travel/kenya1.jpeg';
import Kenya2 from './travel/kenya2.jpeg';
import Kenya3 from './travel/kenya3.jpeg';
import Kenya4 from './travel/kenya4.jpeg';
import Kenya5 from './travel/kenya5.jpeg';
import Kenya6 from './travel/kenya6.jpeg';

import London1 from './travel/london1.jpeg';
import London2 from './travel/london2.jpeg';
import London3 from './travel/london3.jpeg';
import London4 from './travel/london4.jpeg';
import London5 from './travel/london5.jpeg';

import Paris1 from './travel/paris1.jpeg';
import Paris2 from './travel/paris2.jpeg';
import Paris3 from './travel/paris3.jpeg';
import Paris4 from './travel/paris4.jpeg';
import Paris5 from './travel/paris5.jpeg';
import Paris6 from './travel/paris6.jpeg';
import Paris7 from './travel/paris7.jpeg';

import SanFran1 from './travel/sanfran1.jpg';
import SanFran2 from './travel/sanfran2.jpg';
import SanFran3 from './travel/sanfran3.jpg';
import SanFran4 from './travel/sanfran4.jpg';
import SanFran5 from './travel/sanfran5.jpg';
import SanFran6 from './travel/sanfran6.jpg';
import SanFran7 from './travel/sanfran7.jpg';
import SanFran8 from './travel/sanfran8.JPG';
import SanFran9 from './travel/sanfran9.JPG';
import SanFran10 from './travel/sanfran10.JPG';
import SanFran11 from './travel/sanfran11.JPG';
import SanFran12 from './travel/sanfran12.JPG';

import Seattle1 from './travel/seattle1.jpeg';
import Seattle2 from './travel/seattle2.png';
import Seattle3 from './travel/seattle3.jpeg';
import Seattle4 from './travel/seattle4.jpg';
import Seattle5 from './travel/seattle5.png';
import Seattle6 from './travel/seattle6.png';
import Seattle7 from './travel/seattle7.png';
import Seattle8 from './travel/seattle8.png';

import Shanghai1 from './travel/shanghai1.jpeg';
import Shanghai2 from './travel/shanghai2.jpeg';
import Shanghai3 from './travel/shanghai3.jpeg';

import WashDC1 from './travel/washdc1.jpg';
import WashDC2 from './travel/washdc2.jpg';
import WashDC3 from './travel/washdc3.jpg';
import WashDC4 from './travel/washdc4.jpg';
import WashDC5 from './travel/washdc5.JPG';
import WashDC6 from './travel/washdc6.JPG';
import WashDC7 from './travel/washdc7.JPG';
import WashDC8 from './travel/washdc8.JPG';
import WashDC9 from './travel/washdc9.JPG';

import LA1 from './travel/la1.JPG';
import LA2 from './travel/la2.JPG';
import LA3 from './travel/la3.jpg';
import LA4 from './travel/la4.JPG';
import LA5 from './travel/la5.JPG';
import LA6 from './travel/la6.jpg';
import LA7 from './travel/la7.jpg';
import LA8 from './travel/la8.jpg';

export default {
    'paris': [Paris1, Paris2, Paris3, Paris4, Paris5, Paris6, Paris7],
    'heidelberg':[Heidelberg1, Heidelberg2, Heidelberg3, Heidelberg4, Heidelberg5, Heidelberg6, Heidelberg7, Heidelberg8],
    'amsterdam':[ Amsterdam1, Amsterdam2, Amsterdam3, Amsterdam5, Amsterdam6, Amsterdam7, Amsterdam8, Amsterdam9],
    'seattle': [Seattle1, Seattle2, Seattle3, Seattle4, Seattle5, Seattle6, Seattle7, Seattle8],
    'austria': [Austria1, Austria2, Austria3, Austria4],
    'kenya': [Kenya1, Kenya2, Kenya3, Kenya4, Kenya5, Kenya6],
    'beijing':[Beijing1, Beijing2, Beijing3, Beijing4, Beijing5, Beijing6, Beijing7, Beijing8, Beijing9, Beijing10],
    'sanfran': [SanFran1, SanFran2, SanFran3, SanFran4, SanFran5, SanFran6, SanFran7, SanFran8, SanFran9, SanFran10, SanFran11, SanFran12],
    'dr': [DR1, DR3, DR4, DR5, DR6, DR7],
    'guilin':[Guilin1, Guilin2],
    
    'hongkong': [HongKong1, HongKong2, HongKong3, HongKong4, HongKong5],
    'italy': [Italy1, Italy2, Italy3, Italy4, Italy5, Italy6, Italy7, Italy8, Italy9, Italy10, Italy11],
   
    'london': [London1, London2, London3, London4, London5],
    
   'la': [LA1, LA2, LA3, LA4, LA5, LA6, LA7, LA8],
    
    'shanghai': [Shanghai1, Shanghai2, Shanghai3],
    'washdc' : [WashDC1, WashDC2, WashDC3, WashDC4, WashDC5, WashDC6, WashDC7, WashDC8, WashDC9],
};